<template>
  <div class="profile-dialog" @click="handleOutsideClick" data-testid="profile-dialog">
    <div class="profile-content" @click.stop data-testid="profile-content">
      <!-- Profile Header -->
        <div class="profile-header">
          <div class="header-left">
            <div class="avatar-container" @click.stop="triggerAvatarUpload">
              <Avatar :src="userInfo.avatar" :char="userInfo.name" :size="72" class="header-avatar" />
              <div class="avatar-upload-overlay">
                <span class="upload-icon">📷</span>
                <span class="upload-text">点击上传</span>
              </div>
            </div>
          <div class="user-info">
            <h3 class="user-name">{{ userInfo.name }}</h3>
            <div class="uid-section">
              <span class="uid-text">UID: {{ userInfo.id }}</span>
              <span class="switch-account" @click="handleSwitchAccount">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M12.6807 7.66406C12.9541 7.71551 13.1357 7.97958 13.084 8.25391C12.8679 9.40238 12.3267 10.4603 11.5195 11.3125C10.4001 12.4939 8.88774 13.1689 7.26074 13.2129C6.63329 13.23 6.01788 13.1523 5.43066 12.9863C4.49512 12.7218 3.63107 12.2336 2.90527 11.5459C2.54307 11.2027 2.23025 10.824 1.9668 10.4141L1.90137 10.6426C1.82374 10.9093 1.54515 11.0638 1.27832 10.9883L1.27539 10.9873C1.00723 10.9095 0.852878 10.6285 0.930664 10.3604L1.35742 8.8877L1.38477 8.81543C1.38631 8.81213 1.38804 8.80893 1.38965 8.80566C1.39672 8.79126 1.40576 8.77814 1.41406 8.76465C1.42383 8.74882 1.43284 8.73248 1.44434 8.71777C1.4516 8.70847 1.45992 8.70013 1.46777 8.69141C1.48129 8.67639 1.49537 8.66184 1.51074 8.64844C1.52271 8.638 1.53597 8.62936 1.54883 8.62012C1.56133 8.61116 1.57347 8.60162 1.58691 8.59375C1.60414 8.58361 1.62231 8.57543 1.64062 8.56738C1.65043 8.56311 1.65973 8.55741 1.66992 8.55371C1.67209 8.55293 1.67459 8.55251 1.67676 8.55176C1.70015 8.54357 1.7245 8.53887 1.74902 8.53418C1.75695 8.53268 1.76453 8.52943 1.77246 8.52832C1.83009 8.52014 1.88955 8.52323 1.94922 8.53613C1.95533 8.53746 1.96173 8.53751 1.96777 8.53906C1.97197 8.54013 1.97628 8.54081 1.98047 8.54199L1.98438 8.54297C2.00416 8.54872 2.02252 8.55756 2.04102 8.56543C2.04719 8.56807 2.05351 8.57036 2.05957 8.57324C2.08248 8.58409 2.10342 8.59747 2.12402 8.61133C2.13123 8.61617 2.13855 8.62076 2.14551 8.62598C2.16229 8.63858 2.17744 8.65255 2.19238 8.66699C2.20149 8.67577 2.21126 8.68387 2.21973 8.69336C2.23418 8.70962 2.24658 8.72721 2.25879 8.74512C2.26433 8.75323 2.2703 8.76104 2.27539 8.76953C2.29088 8.79536 2.30376 8.82238 2.31445 8.85059C2.31533 8.8529 2.31654 8.85509 2.31738 8.85742C2.58776 9.60365 3.01964 10.2612 3.60059 10.8115C4.58598 11.7452 5.87667 12.2388 7.2334 12.2021C8.59056 12.1654 9.85255 11.6028 10.7861 10.6172C11.4595 9.90642 11.9107 9.02464 12.0908 8.06738C12.1424 7.79308 12.4064 7.61258 12.6807 7.66406ZM6.71973 1.00293C8.34665 0.959049 9.89345 1.55059 11.0752 2.66992C11.4377 3.01338 11.75 3.39328 12.0137 3.80371L12.082 3.57129C12.1598 3.30314 12.4382 3.14351 12.708 3.22656C12.9761 3.30433 13.1304 3.58444 13.0527 3.85254L12.626 5.3252C12.611 5.37668 12.586 5.42259 12.5576 5.46484C12.552 5.47329 12.5471 5.48212 12.541 5.49023C12.5309 5.50355 12.5192 5.5152 12.5078 5.52734C12.4956 5.54057 12.4834 5.55349 12.4697 5.56543C12.4584 5.57519 12.4467 5.58407 12.4346 5.59277C12.4212 5.60253 12.4081 5.6126 12.3936 5.62109C12.3823 5.62761 12.3701 5.63205 12.3584 5.6377C12.3425 5.64544 12.3276 5.65594 12.3105 5.66211C12.048 5.75728 11.7581 5.62095 11.6631 5.3584C11.3927 4.61197 10.9608 3.95464 10.3799 3.4043C9.3944 2.47072 8.10408 1.97705 6.74707 2.01367C5.39005 2.05045 4.12886 2.61318 3.19531 3.59863C2.52211 4.30936 2.07076 5.19108 1.89062 6.14844C1.83902 6.42281 1.57417 6.60336 1.2998 6.55176C1.28459 6.54889 1.26949 6.54508 1.25488 6.54102C1.00624 6.47052 0.847778 6.22093 0.896484 5.96191C1.11259 4.81329 1.65372 3.75548 2.46094 2.90332C3.58034 1.72179 5.09264 1.04697 6.71973 1.00293Z"
                    fill="url(#paint0_linear_5023_7987)" />
                  <defs>
                    <linearGradient id="paint0_linear_5023_7987" x1="0.887695" y1="7.10776" x2="13.0928" y2="7.10776"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#62AFFF" />
                      <stop offset="1" stop-color="#9C41FF" />
                    </linearGradient>
                  </defs>
                </svg>
                切换账号
              </span>
            </div>
          </div>
        </div>
        <div class="header-right">
          <span class="logout-btn" @click="handleLogout">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.9155 3.47252C10.8405 3.42741 10.7751 3.36796 10.723 3.29758C10.671 3.2272 10.6333 3.14725 10.6122 3.06231C10.591 2.97737 10.5868 2.88909 10.5998 2.80252C10.6127 2.71595 10.6426 2.63278 10.6877 2.55777C10.7329 2.48275 10.7923 2.41735 10.8627 2.36531C10.9331 2.31326 11.013 2.27559 11.098 2.25444C11.1829 2.23329 11.2712 2.22908 11.3577 2.24205C11.4443 2.25502 11.5275 2.28491 11.6025 2.33002C12.6392 2.95178 13.4971 3.83159 14.0926 4.88366C14.688 5.93572 15.0006 7.12414 15 8.33302C15 12.199 11.866 15.333 8 15.333C4.134 15.333 1 12.199 1 8.33302C1 5.84452 2.31 3.58202 4.4045 2.32552C4.5562 2.23461 4.73781 2.2077 4.90935 2.25069C5.0809 2.29368 5.22835 2.40306 5.31925 2.55477C5.41015 2.70647 5.43707 2.88807 5.39408 3.05962C5.35108 3.23117 5.2417 3.37861 5.09 3.46952C4.24893 3.97244 3.55277 4.68502 3.0696 5.5376C2.58643 6.39017 2.3328 7.35355 2.3335 8.33352C2.3335 11.4625 4.87 13.9995 8 13.9995C11.13 13.9995 13.6665 11.4625 13.6665 8.33302C13.6665 6.32002 12.6095 4.49102 10.9155 3.47302V3.47252ZM8 0.666016C8.368 0.666016 8.6665 0.964516 8.6665 1.33302V6.66602C8.6665 6.84278 8.59628 7.01231 8.47129 7.1373C8.34629 7.2623 8.17677 7.33252 8 7.33252C7.82323 7.33252 7.65371 7.2623 7.52871 7.1373C7.40372 7.01231 7.3335 6.84278 7.3335 6.66602V1.33302C7.3335 0.964516 7.632 0.666016 8 0.666016Z" fill="#F15D5D"/>
</svg>
            退出登录
          </span>
        </div>
      </div>

      <!-- Personal Details Section -->
      <div class="personal-details-section">
        <div class="section-header">
          <h4 class="section-title">个人详细信息</h4>
          <span v-if="!isEditing" class="edit-link" @click="handleEditPersonalInfo">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M7.69514 11.9148C7.68368 11.9294 7.67223 11.9447 7.66713 11.9631L6.78403 15.2008C6.73245 15.3893 6.78531 15.5924 6.92476 15.7357C7.02919 15.8375 7.1667 15.8936 7.31315 15.8936C7.36154 15.8936 7.40992 15.8878 7.45768 15.8751L10.6724 14.9983C10.6775 14.9983 10.6801 15.0028 10.6839 15.0028C10.7208 15.0028 10.7571 14.9894 10.7845 14.9614L19.3807 6.36646C19.636 6.11084 19.7761 5.76256 19.7761 5.38371C19.7761 4.95425 19.594 4.52513 19.275 4.20707L18.4632 3.39399C18.1448 3.07499 17.715 2.89258 17.2859 2.89258C16.9071 2.89258 16.5588 3.03267 16.3028 3.28765L7.70787 11.8849C7.69898 11.8931 7.70151 11.9052 7.69514 11.9148ZM18.5396 5.52474L17.6857 6.37796L16.3015 4.97177L17.1433 4.13003C17.2763 3.99634 17.5342 4.01577 17.687 4.16919L18.4994 4.98228C18.5842 5.06697 18.6325 5.17964 18.6325 5.29106C18.6319 5.38246 18.5994 5.46523 18.5396 5.52474ZM9.22389 12.0498L15.4267 5.84661L16.8116 7.25374L10.6202 13.4448L9.22389 12.0498ZM8.09373 14.5648L8.54196 12.9195L9.73771 14.1153L8.09373 14.5648Z"
                fill="url(#paint0_linear_5023_7902)" />
              <path
                d="M19.0834 8.93137C18.758 8.93137 18.4912 9.19591 18.49 9.52573V17.539C18.49 17.9593 18.1487 18.3005 17.7278 18.3005H4.17228C3.75206 18.3005 3.40949 17.9593 3.40949 17.539V4.45975C3.40949 4.03918 3.75206 3.69759 4.17228 3.69759H12.9028C13.2301 3.69759 13.4956 3.43179 13.4956 3.10448C13.4956 2.77787 13.2301 2.51172 12.9028 2.51172H4.08188C3.05742 2.51172 2.22363 3.34487 2.22363 4.36996V17.6295C2.22363 18.6546 3.05742 19.4874 4.08188 19.4874H17.8176C18.8427 19.4874 19.6762 18.6546 19.6762 17.6295V9.52191C19.6748 9.19591 19.4087 8.93137 19.0834 8.93137Z"
                fill="url(#paint1_linear_5023_7902)" />
              <defs>
                <linearGradient id="paint0_linear_5023_7902" x1="6.76465" y1="9.39308" x2="19.7761" y2="9.39308"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
                <linearGradient id="paint1_linear_5023_7902" x1="2.22363" y1="10.9995" x2="19.6762" y2="10.9995"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
              </defs>
            </svg>
            编辑个人信息
          </span>
          <span v-else class="complete-btn" @click="handleEdit">
            完成
          </span>
        </div>
        <div class="details-content">
          <div class="detail-row two-column-row">
            <div class="detail-item">
              <span class="detail-label">职务：</span>
              <span v-if="!isEditing" class="detail-value">{{ userInfo.position }}</span>
              <input v-else v-model="editForm.position" class="detail-input" type="text" placeholder="请输入职务" />
            </div>
            <div class="detail-item">
              <span class="detail-label">电话：</span>
              <span v-if="!isEditing" class="detail-value">{{ formatMobile(userInfo.mobile) }}</span>
              <input v-else v-model="editForm.mobile" class="detail-input" type="text" placeholder="请输入手机号" />
            </div>
          </div>
          <div class="detail-row two-column-row">
            <div class="detail-item">
              <span class="detail-label">微信号：</span>
              <span v-if="!isEditing" class="detail-value">{{ userInfo.wechat }}</span>
              <input v-else v-model="editForm.wechat" class="detail-input" type="text" placeholder="请输入微信号" />
            </div>
            <div class="detail-item">
              <span class="detail-label">接收简历邮箱：</span>
              <span v-if="!isEditing" class="detail-value">{{ formatEmail(userInfo.email) }}</span>
              <input v-else v-model="editForm.email" class="detail-input" type="text" placeholder="请输入邮箱" />
            </div>
          </div>
          <div class="detail-row greeting-row">
            <span class="detail-label">常用招呼语：</span>
            <div v-if="!isEditing" class="greeting-content">
              <div v-for="(greeting, index) in userInfo.greetings" :key="index" class="greeting-item">
                <span class="greeting-text">{{ greeting }}</span>
              </div>
              <div v-if="userInfo.greetings?.length === 0" class="greeting-item">
                <span class="greeting-text">暂无招呼语</span>
              </div>
            </div>
            <div v-else class="greeting-edit-content">
              <div v-for="(greeting, index) in editForm.greetings" :key="`greeting-${index}`" class="greeting-edit-item">
                <input 
                  v-model="editForm.greetings[index]" 
                  class="greeting-input" 
                  type="text" 
                  placeholder="请输入常用招呼语" 
                />
                <button class="delete-btn" @click="deleteEditGreeting(index)">删除</button>
                <button 
                  v-if="index === 0" 
                  class="add-btn" 
                  :class="{ disabled: editForm.greetings.length >= 3 }"
                  :disabled="editForm.greetings.length >= 3"
                  @click="addEditGreeting"
                >
                  添加
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Company Information Section -->
      <div class="company-info-section">
        <div class="section-header">
          <h4 class="section-title">所属公司信息</h4>
          <span v-if="!isEditingCompany" class="edit-link" @click="handleEditCompanyInfo">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path
                d="M7.69514 11.9148C7.68368 11.9294 7.67223 11.9447 7.66713 11.9631L6.78403 15.2008C6.73245 15.3893 6.78531 15.5924 6.92476 15.7357C7.02919 15.8375 7.1667 15.8936 7.31315 15.8936C7.36154 15.8936 7.40992 15.8878 7.45768 15.8751L10.6724 14.9983C10.6775 14.9983 10.6801 15.0028 10.6839 15.0028C10.7208 15.0028 10.7571 14.9894 10.7845 14.9614L19.3807 6.36646C19.636 6.11084 19.7761 5.76256 19.7761 5.38371C19.7761 4.95425 19.594 4.52513 19.275 4.20707L18.4632 3.39399C18.1448 3.07499 17.715 2.89258 17.2859 2.89258C16.9071 2.89258 16.5588 3.03267 16.3028 3.28765L7.70787 11.8849C7.69898 11.8931 7.70151 11.9052 7.69514 11.9148ZM18.5396 5.52474L17.6857 6.37796L16.3015 4.97177L17.1433 4.13003C17.2763 3.99634 17.5342 4.01577 17.687 4.16919L18.4994 4.98228C18.5842 5.06697 18.6325 5.17964 18.6325 5.29106C18.6319 5.38246 18.5994 5.46523 18.5396 5.52474ZM9.22389 12.0498L15.4267 5.84661L16.8116 7.25374L10.6202 13.4448L9.22389 12.0498ZM8.09373 14.5648L8.54196 12.9195L9.73771 14.1153L8.09373 14.5648Z"
                fill="url(#paint0_linear_5023_7978)" />
              <path
                d="M19.0834 8.93137C18.758 8.93137 18.4912 9.19591 18.49 9.52573V17.539C18.49 17.9593 18.1487 18.3005 17.7278 18.3005H4.17228C3.75206 18.3005 3.40949 17.9593 3.40949 17.539V4.45975C3.40949 4.03918 3.75206 3.69759 4.17228 3.69759H12.9028C13.2301 3.69759 13.4956 3.43179 13.4956 3.10448C13.4956 2.77787 13.2301 2.51172 12.9028 2.51172H4.08188C3.05742 2.51172 2.22363 3.34487 2.22363 4.36996V17.6295C2.22363 18.6546 3.05742 19.4874 4.08188 19.4874H17.8176C18.8427 19.4874 19.6762 18.6546 19.6762 17.6295V9.52191C19.6748 9.19591 19.4087 8.93137 19.0834 8.93137Z"
                fill="url(#paint1_linear_5023_7978)" />
              <defs>
                <linearGradient id="paint0_linear_5023_7978" x1="6.76465" y1="9.39308" x2="19.7761" y2="9.39308"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
                <linearGradient id="paint1_linear_5023_7978" x1="2.22363" y1="10.9995" x2="19.6762" y2="10.9995"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62AFFF" />
                  <stop offset="1" stop-color="#9C41FF" />
                </linearGradient>
              </defs>
            </svg>
            编辑公司信息
          </span>
          <span v-else class="complete-btn" @click="handleEditCompany">
            完成
          </span>
        </div>
        <div class="company-content">
          <div class="company-row">
            <span class="company-label">公司名称：</span>
            <div class="company-name-section">
              <span class="company-name">{{ userInfo.company_name }}</span>
              <span class="verified-badge" v-if="userInfo.is_verified === 1">已认证</span>
            </div>
            <span v-if="isEditingCompany" class="switch-company-btn">切换公司</span>
          </div>
          <div class="company-row">
            <span class="company-label">公司地址：</span>
            <div class="company-address-section">
              <span v-if="!isEditingCompany" class="company-address">{{ userInfo.company_address }}</span>
              <div v-else class="company-address-edit-group">
                <el-input v-model="companyEditForm.company_address" class="company-input" type="text" placeholder="请输入公司地址" @click="getCurrentLocation" readonly>
                    <template #suffix>
                      <i class="el-icon-location icon-location" @click="getCurrentLocation"></i>
                    </template>
                  </el-input>
                <button type="button" class="select-address-btn" @click.stop="openMapSelector">选择位置</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 隐藏的头像上传输入框 -->
      <input type="file" ref="avatarInput" class="hidden-file-input" accept="image/*" @change="handleAvatarSelected">
    </div>

    <!-- 地图选择器弹窗 -->
    <transition name="fade">
      <div v-if="mapVisible" class="map-modal-overlay" @click="closeMapSelector">
        <div class="map-modal-container" @click.stop>
          <div class="map-modal-header">
            <h3>选择公司地址</h3>
            <button class="map-close-btn" @click="closeMapSelector">
              <i class="el-icon-close"></i>
            </button>
          </div>
          <div class="map-modal-body">
            <div class="map-search-container">
              <el-input
                v-model="searchKeyword"
                placeholder="搜索地点..."
                class="map-search-input"
                @input="searchPlaces"
                clearable
              >
                <template #prefix>
                  <i class="el-icon-search"></i>
                </template>
              </el-input>
            </div>
            
            <div class="map-container" ref="mapContainer">
              <div class="map-placeholder" v-if="!mapLoaded">
                <i class="el-icon-location-outline"></i>
                <p>正在加载地图...</p>
              </div>
            </div>
            
            <div class="search-results" v-if="searchResults.length > 0">
              <div class="search-results-title">搜索结果</div>
              <div class="search-results-list">
                <div 
                  v-for="(place, index) in searchResults" 
                  :key="index"
                  class="search-result-item"
                  @click="selectPlace(place)"
                >
                  <div class="place-name">{{ place.name }}</div>
                  <div class="place-address">{{ place.address }}</div>
                </div>
              </div>
            </div>
            
            <div class="map-actions">
              <button class="cancel-btn" @click="closeMapSelector">取消</button>
              <button class="confirm-btn" @click="confirmLocation" :disabled="!selectedPlace">确认选择</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import { getBusinessCenter, updateBusinessUser } from '@/api/user'
import Avatar from '@/components/Avatar.vue'
import { lxUploadFile } from '@/api/upload'
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: 'Profile',
  components: {
    Avatar
  },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    // 是否允许编辑
    editable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['changePopup'],
  data() {
    return {
      userInfo: {
        name: '',
        position: '',
        mobile: '',
        wechat: '',
        email: '',
        greetings: [],
        company_name: '',
        company_address: '',
        is_verified: 0,
        avatar: '',
        id: ''
      },
      isEditing: false,
      isEditingCompany: false,
      isSaving: false,
      saveTimer: null,
      hasError: false, // 是否有错误
      editForm: {
        position: '',
        mobile: '',
        wechat: '',
        email: '',
        greetings: []
      },
      companyEditForm: {
        company_name: '',
        company_address: ''
      },
      newGreeting: '',
      splitIcon: '$$$$$$',
      // 地图相关
      mapVisible: false,
      mapLoaded: false,
      map: null,
      geocoder: null,
      searchKeyword: '',
      searchResults: [],
      selectedPlace: null,
      currentPosition: null,
      AMap: null,
      config: {
        key: '070c88801a00691beb776e97b827de22',
        securityJsCode: '4e3dc9d8adf7fcd98960bf4af3b42672', 
        version: '2.0',
        plugins: ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.AutoComplete'],
        Loca: { version: '2.0' }
      },
    }
  },
  created() {
    this.getUserInfo()
    this.initAMap()
  },
  activated() {
    // 如果组件被缓存，重新激活时刷新数据
    this.getUserInfo()
  },
  mounted() {
    // 添加键盘事件监听
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeydown)
    // 清理定时器
    if (this.saveTimer) {
      clearTimeout(this.saveTimer)
    }
    // 清理草稿
    localStorage.removeItem('profile_draft')
  },
  computed: {
    // 计算属性：是否显示保存按钮
    showSaveButton() {
      return this.isEditing && !this.isSaving
    },
    // 计算属性：按钮文本
    editButtonText() {
      if (!this.isEditing) return '编辑'
      return this.isSaving ? '保存中...' : '保存'
    },
    // 计算属性：是否有未保存的更改
    hasChanges() {
      if (!this.isEditing) return false
      return this.editForm.position !== (this.userInfo.position || '') ||
        this.editForm.mobile !== (this.userInfo.mobile || '') ||
        this.editForm.wechat !== (this.userInfo.wechat || '') ||
        this.editForm.email !== (this.userInfo.email || '') ||
        this.editForm.greetings !== (this.userInfo.greetings || [])
    }
  },
  watch: {
    // 监听编辑表单变化，自动保存草稿（防抖处理）
    editForm: {
      handler(newVal) {
        if (this.isEditing) {
          // 防抖处理，避免频繁保存
          clearTimeout(this.saveTimer)
          this.saveTimer = setTimeout(() => {
            const draftData = {
              ...newVal,
              greetings: this.convertGreetingsToString(newVal.greetings)
            }
            localStorage.setItem('profile_draft', JSON.stringify(draftData))
          }, 500)
        }
      },
      deep: true
    }
  },
  methods: {
    // 将后端返回的字符串转换为数组
    convertGreetingsToArray(greetings) {
      if (!greetings) return ['']
      if (typeof greetings === 'string') {
        // 如果字符串为空，返回一个空字符串的数组
        if (greetings.trim() === '') return ['']
        // 使用分隔符分割字符串
        return greetings.split(this.splitIcon).filter(item => item.trim() !== '')
      }
      if (Array.isArray(greetings)) {
        return greetings.length > 0 ? greetings : ['']
      }
      return ['']
    },

    // 将前端数组转换为后端需要的字符串
    convertGreetingsToString(greetings) {
      if (!greetings || !Array.isArray(greetings)) return ''
      // 过滤掉空字符串，然后用分隔符连接
      const validGreetings = greetings.filter(item => item && item.trim() !== '')
      return validGreetings.join(this.splitIcon)
    },

    async getUserInfo() {
      try {
        const response = await getBusinessCenter()
        if (response.data.code === 1) {
          this.userInfo = response.data.data || {}
          // 将后端返回的字符串转换为数组
          this.userInfo.greetings = this.convertGreetingsToArray(this.userInfo.greetings)
          // 初始化编辑表单
          this.initEditForm()
        } else {
          console.error('获取用户信息失败：', response.msg)
          this.$message.warning(response.data.msg || '获取用户信息失败')
        }
      } catch (error) {
        console.error('接口请求异常：', error)
        this.hasError = true
        if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
          this.$message.error('网络连接失败，请检查网络后重试')
        } else {
          this.$message.error('网络异常，请稍后重试')
        }
        // 如果是网络错误，可以在这里添加重试逻辑
        // 设置默认用户信息，避免界面显示异常
        this.userInfo = {
          name: '用户',
          position: '',
          mobile: '',
          wechat: '',
          email: '',
          greetings: '',
          company_name: '',
          is_verified: 0,
          avatar: ''
        }
      }
    },
    initEditForm() {
      // 尝试从本地存储恢复草稿
      const draft = localStorage.getItem('profile_draft')
      if (draft) {
        try {
          const draftData = JSON.parse(draft)
          this.editForm = {
            position: draftData.position || this.userInfo.position || '',
            mobile: draftData.mobile || this.userInfo.mobile || '',
            wechat: draftData.wechat || this.userInfo.wechat || '',
            email: draftData.email || this.userInfo.email || '',
            greetings: this.convertGreetingsToArray(draftData.greetings) || this.userInfo.greetings || ['']
          }
          // 提示用户有草稿
          this.$message.info('检测到未保存的草稿，已自动恢复')
        } catch (error) {
          console.error('解析草稿失败：', error)
          this.initDefaultForm()
        }
      } else {
        this.initDefaultForm()
      }
    },
    initDefaultForm() {
      this.editForm = {
        position: this.sanitizeInput(this.userInfo.position) || '',
        mobile: this.sanitizeInput(this.userInfo.mobile) || '',
        wechat: this.sanitizeInput(this.userInfo.wechat) || '',
        email: this.sanitizeInput(this.userInfo.email) || '',
        greetings: Array.isArray(this.userInfo.greetings) && this.userInfo.greetings.length > 0 
          ? this.userInfo.greetings 
          : [''] // 默认有一条空招呼语
      }
    },
    // 输入净化，防止XSS攻击
    sanitizeInput(input) {
      if (!input) return ''
      return String(input).replace(/[<>]/g, '')
    },
    formatMobile(mobile) {
      if (!mobile || mobile.length !== 11) return mobile
      return mobile.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1****$3')
    },
    formatEmail(email) {
      if (!email) return email
      const [username, domain] = email.split('@')
      if (username && domain) {
        const maskedUsername = username.length > 2
          ? username.substring(0, 4) + '****'
          : username + '****'
        return `${maskedUsername}@${domain}`
      }
      return email
    },
    // 切换账号
    handleSwitchAccount() {
      console.log('切换账号')
      this.$emit('changePopup', null)
      // 这里可以添加切换账号的逻辑
    },

    // 触发头像上传
    triggerAvatarUpload() {
      try {
        this.$nextTick(() => {
          if (this.$refs && this.$refs.avatarInput) {
            this.$refs.avatarInput.click();
          } else {
            console.error('avatarInput ref not found');
          }
        });
      } catch (error) {
        console.error('Error triggering avatar upload:', error);
      }
    },

    // 处理头像选择
    handleAvatarSelected(event) {
      try {
        const file = event.target.files[0];
        if (!file) return;

        // 检查文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('请选择图片文件');
          return;
        }

        // 检查文件大小 (限制为2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$message.error('图片大小不能超过2MB');
          return;
        }

        // 创建预览URL
        const reader = new FileReader();
        reader.onload = (e) => {
          this.userInfo.avatar = e.target.result;
          this.uploadAvatar(file);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.error('Error handling avatar selection:', error);
        this.$message.error('处理头像选择时出错');
      }
    },

    // 上传头像到服务器
    async uploadAvatar(file) {
      try {
        // 第一步：上传图片到对象存储
        const formData = new FormData();
        formData.append('file', file);
        const response = await lxUploadFile(formData);
        
        if (response && response.data && response.data.data && response.data.data.url) {
          const imageUrl = response.data.data.url;
          
          // 第二步：更新企业用户信息
          const updateData = {
            ...this.userInfo,
            avatar: imageUrl,
            greetings: this.convertGreetingsToString(this.userInfo.greetings)
          };
        
          const updateResponse = await updateBusinessUser(updateData);
          if(updateResponse.data.code === 1) {
            this.$message.success('头像上传成功');
            this.userInfo.avatar = imageUrl;
          } else {
            this.$message.error(updateResponse.data.msg || '头像上传失败');
            this.userInfo.avatar = '';
          }
        } else {
          this.$message.error(response.data.msg || '图片上传失败');
          // 恢复原来的头像
          this.userInfo.avatar = '';
        }
      } catch (error) {
        this.$message.error('头像上传失败，请重试');
        // 恢复原来的头像
        this.userInfo.avatar = '';
      }
    },


    // 删除编辑中的招呼语
    deleteEditGreeting(index) {
      const newGreetings = [...this.editForm.greetings];
      newGreetings.splice(index, 1);
      
      // 如果删除后数组为空，添加一个空字符串
      if (newGreetings.length === 0) {
        newGreetings.push('');
      }
      
      this.$set(this.editForm, 'greetings', newGreetings);
    },

    // 添加编辑中的招呼语
    addEditGreeting() {
      if (this.editForm.greetings?.length >= 3) {
        this.$message.warning('最多只能添加3条招呼语');
        return;
      }
      
      // 确保greetings是数组
      if (!Array.isArray(this.editForm.greetings)) {
        this.$set(this.editForm, 'greetings', ['']);
      }
      
      // 直接添加一个空字符串
      const newGreetings = [...this.editForm.greetings, ''];
      this.$set(this.editForm, 'greetings', newGreetings);
    },

    // 编辑个人信息
    handleEditPersonalInfo() {
      console.log('编辑个人信息')
      this.isEditing = true
      this.initEditForm()
    },
    // 编辑公司信息
    handleEditCompanyInfo() {
      console.log('编辑公司信息')
      this.isEditingCompany = true
      this.initCompanyEditForm()
    },
    // 完成编辑公司信息
    async handleEditCompany() {
      console.log('完成编辑公司信息')
      
      // 验证表单
      if (!this.validateCompanyForm()) {
        return
      }

      // 保存编辑
      this.isSaving = true
      try {
        // 准备API参数，传入原来的信息加上company_address
        const updateData = {
          avatar: this.userInfo.avatar || '',
          email: this.userInfo.email || '',
          greetings: this.convertGreetingsToString(this.userInfo.greetings),
          name: this.userInfo.name || '',
          position: this.userInfo.position || '',
          wechat: this.userInfo.wechat || '',
          company_address: this.companyEditForm.company_address
        }
        
        // 调用API保存公司信息
        const response = await updateBusinessUser(updateData)
        if (response.data.code === 1) {
          // 更新本地数据
          this.userInfo = { 
            ...this.userInfo, 
            company_address: this.companyEditForm.company_address
          }
          this.isEditingCompany = false
          this.$message.success('公司信息更新成功')
        } else {
          this.$message.error(response.data.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败：', error)
        if (error.response && error.response.data && error.response.data.msg) {
          this.$message.error(error.response.data.msg)
        } else if (error.message) {
          this.$message.error(error.message)
        } else {
          this.$message.error('保存失败，请重试')
        }
      } finally {
        this.isSaving = false
      }
    },
    // 初始化公司编辑表单
    initCompanyEditForm() {
      this.companyEditForm = {
        company_name: this.userInfo.company_name || '',
        company_address: this.userInfo.company_address || ''
      }
    },
    // 获取当前位置
    getCurrentLocation() {
      if (!navigator.geolocation) {
        this.$message.error('您的浏览器不支持地理定位功能')
        return
      }

      // 检查地图服务是否已加载
      if (!this.AMap || !this.geocoder) {
        this.$message.warning('地图服务正在加载中，请稍后再试')
        return
      }

      this.$message.info('正在获取当前位置...')
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          this.currentPosition = { lat: latitude, lng: longitude }
          this.reverseGeocode(latitude, longitude)
        },
        (error) => {
          console.error('获取位置失败:', error)
          let errorMessage = '获取位置失败'
          switch(error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = '用户拒绝了地理定位请求'
              break
            case error.POSITION_UNAVAILABLE:
              errorMessage = '位置信息不可用'
              break
            case error.TIMEOUT:
              errorMessage = '获取位置超时'
              break
          }
          this.$message.error(errorMessage)
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        }
      )
    },
    // 逆地理编码
    reverseGeocode(lat, lng) {
      if (!this.geocoder) {
        this.$message.warning('地图服务未加载，无法获取地址')
        return
      }
      
      this.geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.companyEditForm.company_address = result.regeocode.formattedAddress
          this.$message.success('位置获取成功')
        } else {
          this.$message.error('地址解析失败，请手动输入地址')
        }
      })
    },
    // 打开地图选择器
    openMapSelector() {
      this.mapVisible = true
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedPlace = null
      
      // 等待DOM渲染完成后初始化地图
      this.$nextTick(() => {
        if (!this.mapLoaded && this.AMap) {
          // 如果地图API已加载但地图实例未创建，现在创建
          this.initMap()
        }
        
        // 调整地图视图
        setTimeout(() => {
          if (this.map) {
            this.map.setFitView()
          }
        }, 200)
      })
    },
    // 关闭地图选择器
    closeMapSelector() {
      this.mapVisible = false
      this.searchKeyword = ''
      this.searchResults = []
      this.selectedPlace = null
    },
    
    // AMapLoader相关方法
    async initAMap() {
      try {
        this.AMap = await AMapLoader.load(this.config)
        
        // 立即创建地理编码器，不依赖地图实例
        this.geocoder = new this.AMap.Geocoder({
          city: '全国'
        })
        
        console.log('地图API和地理编码器加载完成')
      } catch (error) {
        console.error('AMap initialization failed:', error)
        this.$message.error(`地图加载失败: ${error.message}`)
      }
    },

    initMap() {
      if (!this.AMap) {
        console.error('高德地图API未加载')
        return
      }
      
      // 如果地图容器不存在，延迟初始化
      if (!this.$refs.mapContainer) {
        console.log('地图容器未找到，将在DOM渲染后初始化')
        return
      }
      
      try {
        this.map = new this.AMap.Map(this.$refs.mapContainer, {
          zoom: 13,
          center: [116.397428, 39.90923], 
          mapStyle: 'amap://styles/normal'
        })
        
        this.mapLoaded = true
        
        this.map.on('click', (e) => {
          this.handleMapClick(e.lnglat)
        })
        
        console.log('地图实例创建完成')
      } catch (error) {
        console.error('地图实例创建失败:', error)
        this.$message.error('地图创建失败: ' + error.message)
      }
    },

    async searchLocation() {
      if (!this.searchKeyword.trim()) {
        this.searchResults = []
        return
      }
      
      if (!this.AMap) {
        this.$message.warning('地图服务未加载，无法搜索地点')
        this.searchResults = []
        return
      }
      
      const placeSearch = new this.AMap.PlaceSearch({
        city: '深圳',
        pageSize: 10
      })
      
      placeSearch.search(this.searchKeyword, (status, result) => {
        if (status === 'complete' && result.poiList) {
          this.searchResults = result.poiList.pois.map(poi => ({
            name: poi.name,
            address: poi.address,
            location: poi.location
          }))
        } else {
          this.searchResults = []
          this.$message.warning('未找到相关地点，请尝试其他关键词')
        }
      })
    },

    handleMapClick(lnglat) {
      const location = [lnglat.lng, lnglat.lat]
      
      if (this.geocoder) {
        this.geocoder.getAddress(location, (status, result) => {
          if (status === 'complete' && result.regeocode) {
            this.selectedPlace = {
              name: '点击位置',
              address: result.regeocode.formattedAddress,
              location: location
            }
            
            // 清除之前的标记
            this.map.clearMap()
            
            // 添加新标记
            const marker = new this.AMap.Marker({
              position: location,
              title: '选择的位置'
            })
            this.map.add(marker)
          } else {
            this.$message.error('地址解析失败')
          }
        })
      }
    },

    confirmLocation() {
      if (this.selectedPlace) {
        this.companyEditForm.company_address = this.selectedPlace.address
        this.closeMapSelector()
        this.$message.success('地址选择成功')
      } else {
        this.$message.warning('请先选择一个位置')
      }
    },
    // 选择地点
    selectPlace(place) {
      this.selectedPlace = place
      
      if (this.map && this.AMap) {
        this.map.clearMap()
        const marker = new this.AMap.Marker({
          position: place.location,
          title: place.name
        })
        this.map.add(marker)
        this.map.setCenter(place.location)
      } else {
        this.$message.warning('地图未正确加载，无法标记位置')
      }
    },
    
    // 点击外部关闭弹窗
    handleOutsideClick(event) {
      if (event.target === event.currentTarget) {
        // 如果正在编辑，重置编辑状态
        if (this.isEditing) {
          this.isEditing = false
          // 清除草稿
          localStorage.removeItem('profile_draft')
          this.initDefaultForm()
        }
        this.$emit('changePopup', null)
      }
    },
    // 新增：关闭按钮点击事件
    handleClose() {
      // 如果正在编辑，重置编辑状态
      if (this.isEditing) {
        this.isEditing = false
        // 清除草稿
        localStorage.removeItem('profile_draft')
        this.initDefaultForm()
      }
      this.$emit('changePopup', null)
    },
    // 编辑按钮点击
    async handleEdit() {
      if (this.isEditing) {
        // 验证表单
        if (!this.validateForm()) {
          return
        }

        // 保存编辑
        this.isSaving = true
        try {
          // 准备API参数，按照要求的格式
          const updateData = {
            avatar: this.userInfo.avatar || '',
            email: this.editForm.email || '',
            greetings: this.convertGreetingsToString(this.editForm.greetings),
            name: this.userInfo.name || '',
            position: this.editForm.position || '',
            wechat: this.editForm.wechat || ''
          }
          
          // 调用API保存用户信息
          const response = await updateBusinessUser(updateData)
          if (response.data.code === 1) {
            // 更新本地数据
            this.userInfo = { 
              ...this.userInfo, 
              position: this.editForm.position,
              email: this.editForm.email,
              wechat: this.editForm.wechat,
              greetings: this.editForm.greetings
            }
            this.isEditing = false
            // 清除本地存储的草稿
            localStorage.removeItem('profile_draft')
            this.$message.success('个人资料更新成功')
            // 可以选择自动关闭弹窗
            // this.$emit('changePopup', null)
          } else {
            this.$message.error(response.data.msg || '保存失败')
          }
        } catch (error) {
          console.error('保存失败：', error)
          if (error.response && error.response.data && error.response.data.msg) {
            this.$message.error(error.response.data.msg)
          } else if (error.message) {
            this.$message.error(error.message)
          } else {
            this.$message.error('保存失败，请重试')
          }
        } finally {
          this.isSaving = false
        }
      } else {
        // 进入编辑模式
        this.isEditing = true
        this.initEditForm()
      }
    },
    // 表单验证
    validateForm() {
      // 手机号验证
      if (this.editForm.mobile && !/^1[3-9]\d{9}$/.test(this.editForm.mobile)) {
        this.$message.error('请输入正确的手机号')
        return false
      }

      // 邮箱验证
      if (this.editForm.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editForm.email)) {
        this.$message.error('请输入正确的邮箱地址')
        return false
      }

      // 微信号验证（可选）
      if (this.editForm.wechat && this.editForm.wechat.length < 6) {
        this.$message.error('微信号长度不能少于6位')
        return false
      }

      return true
    },
    // 公司信息表单验证
    validateCompanyForm() {
      // 公司地址验证
      if (!this.companyEditForm.company_address || this.companyEditForm.company_address.trim() === '') {
        this.$message.error('请输入公司地址')
        return false
      }

      return true
    },
    // 键盘事件处理
    handleKeydown(event) {
      if (event.key === 'Escape' && this.isEditing) {
        this.handleCancel()
      }
    },
    // 取消编辑
    handleCancel() {
      this.isEditing = false
      // 清除草稿
      localStorage.removeItem('profile_draft')
      this.initDefaultForm() // 重新初始化表单，恢复原始数据
    },
    // 更换公司点击
    handleChangeCompany() {
      console.log('点击更换公司')
      this.$emit('changePopup', null)
    },
    // 退出登录点击
    async handleLogout() {
      try {
        // 调用Vuex的退出登录
        await this.$store.dispatch('user/logout')
        this.$message.success('已成功退出登录')
        this.handleClose()
        this.$router.push('/store/entry')
      } catch (error) {
        console.error('退出登录失败：', error)
        // 如果API调用失败，至少清理本地状态
        this.$store.dispatch('auth/logout')
        this.$message.success('已成功退出登录')
        this.handleClose()
        this.$router.push('/store/entry')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.profile-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.profile-content {
  width: 800px;
  max-height: 80vh;
  background: var(--Linear, linear-gradient(321deg, rgba(255, 255, 255, 0.40) 2.06%, rgba(255, 255, 255, 0.72) 42.17%, rgba(255, 255, 255, 0.80) 99.08%));
  border-radius: 12px;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
backdrop-filter: blur(15px);

  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

// Profile Header
.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  border-bottom: 1px solid #f0f0f0;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;

      .avatar-container {
        position: relative;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      .avatar-container:hover .avatar-upload-overlay {
        opacity: 1;
      }

      .avatar-upload-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.2s ease;
        color: white;
        font-size: 12px;
      }

    .header-avatar {
      flex-shrink: 0;
    }

    .user-info {
      .user-name {
        margin: 0 0 8px 0;
        font-size: 14px;
        font-weight: 600;
        color: #656587;
      }

      .uid-section {
        display: flex;
        align-items: center;
        gap: 12px;

        .uid-text {
          font-size: 12px;
          color: #666;
        }

        .switch-account {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 14px;
          background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          cursor: pointer;
          text-decoration: none;

          .switch-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }

  .header-right {
    .logout-btn {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      color: #F15D5D;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 6px;
      margin-top:4px;
      transition: all 0.2s;

      &:hover {
        background-color: #f5f5f5;
      }

      .logout-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
}

// Personal Details Section
.personal-details-section {
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #f0f0f0;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .edit-link {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      cursor: pointer;
      text-decoration: none;

      .edit-icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  .details-content {
    .detail-row {
      display: flex;
      margin-bottom: 20px;
      align-items: flex-start;

      .detail-label {
        width: 120px;
        color: #656587;
        font-family: "Source Han Sans CN VF";
        font-size: 16px;
        font-style: normal;
        flex-shrink: 0;
        line-height: 1.4;
        text-align: left;
      }

      .detail-value {
        color: #656587;
        font-family: "Source Han Sans CN VF";
        font-size: 16px;
        font-style: normal;
        flex: 1;
        line-height: 1.4;
        margin-left: 16px;
      }

      &.two-column-row {
        gap: 24px;

        .detail-item {
          flex: 1;
          display: flex;
          align-items: flex-start;

          .detail-label {
            width: 120px;
            color: #656587;
            font-family: "Source Han Sans CN VF";
            font-size: 16px;
            font-style: normal;
            flex-shrink: 0;
            line-height: 1.4;
            text-align: left;
          }

          .detail-value {
            color: #656587;
            font-family: "Source Han Sans CN VF";
            font-size: 16px;
            font-style: normal;
            flex: 1;
            line-height: 1.4;
            margin-left: 16px;
          }

          .detail-input {
            color: #656587;
            font-family: "Source Han Sans CN VF";
            font-size: 16px;
            font-style: normal;
            flex: 1;
            line-height: 1.4;
            margin-left: 16px;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            padding: 6px 10px;
            background-color: #fff;
            outline: none;
            transition: border-color 0.2s;
            min-height: 32px;
            box-sizing: border-box;

            &:focus {
              border-color: #62AFFF;
            }
          }
        }
      }

      &.greeting-row {
        align-items: flex-start;

        .greeting-content {
          flex: 1;
          margin-left: 16px;

            .greeting-item {

              .greeting-text {
                color: #656587;
                font-family: "Source Han Sans CN VF";
                font-size: 16px;
                font-style: normal;
              }
            }
        }

        .greeting-edit-content {
          flex: 1;
          margin-left: 16px;
          width: 100%;

          .greeting-edit-item {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            gap: 8px;
            width: 100%;

            .greeting-input {
              width: 480px;
              color: #656587;
              font-family: "Source Han Sans CN VF";
              font-size: 16px;
              font-style: normal;
              line-height: 1.4;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              padding: 6px 10px;
              background-color: #fff;
              outline: none;
              transition: border-color 0.2s;
              min-height: 32px;
              box-sizing: border-box;

              &:focus {
                border-color: #62AFFF;
              }
            }

            .delete-btn {
              background: none;
              border: none;
              color: #9C41FF;
              font-size: 14px;
              cursor: pointer;
              padding: 4px 8px;
              border-radius: 4px;
              transition: all 0.2s ease;
              margin-left: 8px;

              &:hover {
                background: rgba(156, 65, 255, 0.1);
              }
            }

            .add-btn {
              color: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);              ;
              border: 1px solid;
              border-image-source: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
              font-size: 14px;
              cursor: pointer;
              padding: 4px 16px;
              border-radius: 6px;
              transition: all 0.2s ease;
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
              border-image: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%) 1;

              &:hover:not(.disabled) {
                opacity: 0.9;
                transform: scale(1.05);
              }

              &.disabled {
                background: #ccc;
                color: #999;
                cursor: not-allowed;
                opacity: 0.6;
                padding: 4px 16px;
                border-image: unset;
                -webkit-text-fill-color: unset
              }
            }
          }
        }
      }
    }
  }

}

// Company Information Section
.company-info-section {
  padding: 16px 24px 24px 24px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .section-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .edit-link {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 14px;
      background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      cursor: pointer;
      text-decoration: none;

      .edit-icon {
        width: 16px;
        height: 16px;
      }
    }
  }

  .company-content {
    .company-row {
      display: flex;
      margin-bottom: 20px;
      align-items: flex-start;

      .company-label {
        width: 120px;
        color: #656587;
        font-family: "Source Han Sans CN VF";
        font-size: 16px;
        font-style: normal;
        flex-shrink: 0;
        line-height: 1.4;
        text-align: left;
      }

      .company-name-section {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 16px;

        .company-name {
          color: #656587;
          font-family: "Source Han Sans CN VF";
          font-size: 16px;
          font-style: normal;
          line-height: 1.4;
        }

        .verified-badge {
          background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
          color: #fff;
          padding: 2px 8px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 500;
        }

      }

      .company-address-section {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 16px;

        .company-address {
          color: #656587;
          font-family: "Source Han Sans CN VF";
          font-size: 16px;
          font-style: normal;
          line-height: 1.4;
        }

        .company-address-edit-group {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;
          
          .company-input {
            flex: 1;
            
            ::v-deep .el-input__inner {
              color: #656587;
              font-family: "Source Han Sans CN VF";
              font-size: 16px;
              font-style: normal;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              padding: 8px 12px;
              transition: border-color 0.3s ease;
              cursor: pointer;
              background-color: #fff;
              
              &:hover {
                border-color: #7EB4EB;
              }
              
              &::placeholder {
                color: #999;
              }
              
              &:focus {
                border-color: #7EB4EB;
                box-shadow: 0 0 0 2px rgba(126, 180, 235, 0.1);
              }
            }
            
            .icon-location {
              color: #7EB4EB;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              transition: color 0.3s ease;
              
              &:hover {
                color: #B16EF9;
              }
            }
          }
          
          .select-address-btn {
            background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
            border: none;
            color: white;
            font-size: 14px;
            cursor: pointer;
            padding: 8px 16px;
            border-radius: 4px;
            font-weight: 500;
            transition: all 0.3s ease;
            flex-shrink: 0;
            white-space: nowrap;
            
            &:hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
              opacity: 0.9;
            }
            
            &:active {
              transform: translateY(0);
            }
          }
        }
      }

      .switch-company-btn {
        background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        border: 1px solid;
        border-image: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%) 1;
        border-radius: 4px;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s;
        flex-shrink: 0;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}

// 全局完成按钮样式
.complete-btn {
  display: inline-block;
  background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1;
  font-family: "Source Han Sans CN VF", sans-serif;
  text-decoration: none;
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);

  &:hover {
    opacity: 0.9;
  }
}

// 隐藏滚动条
.profile-content::-webkit-scrollbar {
  display: none;
}

// 隐藏文件输入框
.hidden-file-input {
  display: none;
}

// 地图相关样式
.map-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.map-modal-container {
  background: white;
  border-radius: 12px;
  width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.map-modal-header {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h3 {
    color: white;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
  
  .map-close-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    
    i {
      font-size: 18px;
    }
  }
}

.map-modal-body {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  
  .map-search-container {
    margin-bottom: 16px;
    
    .map-search-input {
      ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1px solid #d1d5db;
        padding: 12px 16px;
        font-size: 14px;
        
        &:focus {
          border-color: #7EB4EB;
          box-shadow: 0 0 0 3px rgba(126, 180, 235, 0.1);
        }
      }
    }
  }
  
  .map-container {
    flex: 0 0 300px;
    min-height: 300px;
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
    position: relative;
    
    .map-placeholder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f8f9fa;
      
      i {
        font-size: 48px;
        color: #7EB4EB;
        margin-bottom: 16px;
      }
      
      p {
        color: #6b7280;
        font-size: 14px;
        margin: 4px 0;
      }
    }
  }
  
  .search-results {
    margin-bottom: 16px;
    flex-shrink: 0;
    
    .search-results-title {
      font-size: 14px;
      font-weight: 600;
      color: #374151;
      margin-bottom: 8px;
    }
    
    .search-results-list {
      max-height: 150px;
      overflow-y: auto;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      
      .search-result-item {
        padding: 12px 16px;
        border-bottom: 1px solid #f3f4f6;
        cursor: pointer;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: #f8f9fa;
        }
        
        &:last-child {
          border-bottom: none;
        }
        
        .place-name {
          font-size: 14px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 4px;
        }
        
        .place-address {
          font-size: 12px;
          color: #6b7280;
        }
      }
    }
  }
  
  .map-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-shrink: 0;
    margin-top: auto;
    
    .cancel-btn {
      background: white;
      border: 1px solid #d1d5db;
      color: #6b7280;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover {
        border-color: #9ca3af;
        background: #f9fafb;
      }
    }
    
    .confirm-btn {
      background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
      border: none;
      color: white;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
      }
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>